import React from 'react'
import { Grid } from '@material-ui/core'
import Typography from '../../../components/common/Typography'
import { useTrans } from '../../../services/i18n'

const Header = () => {
  const { trans } = useTrans()

  return (
    <Grid container spacing={2} direction="column">
      <Grid item xs zeroMinWidth>
        <Typography
          style={{
            fontFamily: 'Lexend',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '28px',
            lineHeight: '35px',
          }}
        >
          {trans('role-editor')}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default Header
